/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Broker_Action_MappedInputs */

const cs_import_broker_action_mapped = /** @type {(inputs: Import_Broker_Action_MappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napárovaný`)
};

const en_import_broker_action_mapped = /** @type {(inputs: Import_Broker_Action_MappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapped`)
};

/**
* | output |
* | --- |
* | "Mapped" |
*
* @param {Import_Broker_Action_MappedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_broker_action_mapped = /** @type {((inputs?: Import_Broker_Action_MappedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Broker_Action_MappedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_broker_action_mapped(inputs)
	return cs_import_broker_action_mapped(inputs)
});